export default function Badge({ children, badgeColour }) {
  return (
    <div
      role="status"
      className={
        "text-bold z-10 flex size-3 items-center justify-center rounded-full p-2 text-2xs font-medium text-white " +
        badgeColour
      }
    >
      {children}
    </div>
  )
}
